import React, { lazy, Suspense } from 'react';
import { OverlayModalComponentProps, PiletApi } from '@sharefiledev/sharefile-appshell';
import { Spin } from 'antd';

export const clientDashboardModals = {
	showHelp: 'urn:sfmodal:client-dashboard:show-help' as const,
	showTour: 'urn:sfmodal:client-dashboard:show-tour' as const,
};

export type TourOverlayParams = {
	allowSwitchToClassic: boolean;
};

export type TourModalProps = TourOverlayParams &
	Pick<
		OverlayModalComponentProps<typeof clientDashboardModals.showTour>,
		'completeInteraction' | 'cancelInteraction'
	>;

const LazyHelpModal = lazy(() => import('./HelpModal'));
export const AsyncHelpModal: React.FC<{ piletApi: PiletApi }> = props => (
	<Suspense fallback={<Spin />}>
		<LazyHelpModal {...props} />
	</Suspense>
);

const LazyTourModal = lazy(() => import('./TourModal'));
export const AsyncTourModal: React.FC<TourModalProps> = props => (
	<Suspense fallback={<Spin />}>
		<LazyTourModal {...props} />
	</Suspense>
);
